<template>
  <menu :class="className">
    <div class="navigation-side__content">
      <header class="navigation-side__header">
        <span>
          <button v-if="currentNavSection" class="navigation-side__close" @click="closeNavSection">
            <SvgIcon id="arrow" class="-reverse" />
          </button>
        </span>

        <button class="navigation-side__close" @click="$emit('close')">
          <SvgIcon id="close" />
        </button>
      </header>

      <ul v-if="!currentNavSectionKey" class="navigation-side__list">
        <RouterLink
          :style="{ transitionDelay: `150ms` }"
          class="navigation-side__item navigation-side__cascade-item"
          :to="{ name: 'home' }"
          @click.native="$emit('close')"
        >
          Accueil
        </RouterLink>

        <li
          v-for="(section, key, linkIndex) in navSections"
          :key="key"
          :style="{ transitionDelay: `${200 + linkIndex * 50}ms` }"
          class="navigation-side__item navigation-side__cascade-item"
        >
          <button @click.stop="setCurrentNavSectionKey(key)">
            {{ section.label }}
          </button>
        </li>

        <li class="navigation-side__item navigation-side__cascade-item">
          <RouterLink
            :style="{ transitionDelay: `${200 + Object.keys(navSections).length * 50}ms` }"
            :to="{ name: 'contact' }"
            class="button navigation-side__cascade-item"
            @click.native="$emit('close')"
          >
            Nous contacter
          </RouterLink>
        </li>
      </ul>

      <template v-else>
        <ul class="navigation-side__list">
          <li v-scroll:reveal="{ delay: 50 }" class="navigation-side__item">
            <RouterLink :to="currentNavSection.main.route" @click.native="$emit('close')">
              {{ currentNavSection.main.title }}
            </RouterLink>
          </li>
        </ul>

        <ul
          v-for="(section, sectionIndex) in currentNavSection.sections"
          :key="section.title"
          class="navigation-side__list"
        >
          <li
            v-for="(link, linkIndex) in section.links"
            :key="link.label"
            v-scroll:reveal="{ delay: 100 + sectionIndex * 50 + linkIndex * 50 }"
            class="navigation-side__item"
          >
            <RouterLink v-if="link.route" :to="link.route" @click.native="$emit('close')">
              {{ link.label }}
            </RouterLink>

            <a v-else-if="link.url" :href="link.url" target="_blank" rel="noopener noreferrer">
              {{ link.label }}
            </a>
          </li>
        </ul>
      </template>
    </div>
  </menu>
</template>

<script>
export default {
  name: 'NavigationSide',
  props: {
    isOpen: { type: Boolean, default: false },
    navSections: { type: Object, required: true }
  },
  data() {
    return {
      currentNavSectionKey: null
    }
  },
  computed: {
    className() {
      return ['navigation-side', { '-open': this.isOpen }]
    },
    currentNavSection() {
      if (!this.currentNavSectionKey || !this.navSections[this.currentNavSectionKey]) return null
      return this.navSections[this.currentNavSectionKey]
    }
  },
  watch: {
    isOpen(isOpen, wasOpen) {
      if (isOpen === wasOpen) return

      if (isOpen) {
        this.$scroll.prevent()
      } else {
        this.closeNavSection()
        this.$scroll.restore()
      }
    }
  },
  methods: {
    setCurrentNavSectionKey(key) {
      if (this.currentNavSectionKey === key) {
        this.closeNavSection()
      } else {
        this.currentNavSectionKey = key
      }
    },
    closeNavSection() {
      this.currentNavSectionKey = null
    }
  }
}
</script>
